"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var rxjs_1 = require("rxjs");

var operators_1 = require("rxjs/operators");

var PlayerState_1 = __importDefault(require("../constants/PlayerState"));
/**
 * Determines whether or not the loader should be visible to the user.
 */


var shouldBeVisible = function shouldBeVisible(playerState, autoPlay, playQueued) {
  return playerState === PlayerState_1["default"].BUFFERING || playerState === PlayerState_1["default"].SEEKING || (playerState === PlayerState_1["default"].LOADING || playerState === PlayerState_1["default"].STOPPED) && (autoPlay || playQueued);
};

exports.createLoaderObservable = function (props$) {
  var autoPlay$ = props$.pipe(operators_1.map(function (props) {
    return props.autoPlay;
  }));
  var playerState$ = props$.pipe(operators_1.map(function (props) {
    return props.playerState;
  }));
  var playQueued$ = props$.pipe(operators_1.map(function (props) {
    return props.playQueued;
  }));
  var visible$ = rxjs_1.combineLatest(playerState$, autoPlay$, playQueued$).pipe( // Debounce for a short peroid when seeking or buffering, because it is
  // likely that the video will start playing very soon.
  operators_1.debounce(function (_a) {
    var playerState = _a[0],
        autoPlay = _a[1],
        playQueued = _a[2];
    return rxjs_1.timer(playerState === PlayerState_1["default"].SEEKING || playerState === PlayerState_1["default"].BUFFERING ? 400 : 0);
  }), operators_1.map(function (_a) {
    var playerState = _a[0],
        autoPlay = _a[1],
        playQueued = _a[2];
    return shouldBeVisible(playerState, autoPlay, playQueued);
  }));
  return visible$.pipe(operators_1.distinctUntilChanged());
};

exports["default"] = exports.createLoaderObservable;